import { flow } from "fp-ts/lib/function";

import {
    type LensCtaWebsite,
    type MyLensesLensCta,
    type MyLensesLensCtaDeeplink,
    MyLensesLensCtaText,
    MyLensesLensCtaType,
} from "../../gql-generated/types";
import { type GetLensInfoResponse } from "../../lens/api/queries";

const updateLensCtaDeeplink =
    (deeplink?: MyLensesLensCtaDeeplink) =>
    (lensCtaDraft: MyLensesLensCta): MyLensesLensCta => {
        if (!deeplink) return lensCtaDraft;

        const { androidAppUrl, appName, iosAppId, uri } = deeplink;

        return {
            ...lensCtaDraft,
            deeplink: {
                androidAppUrl,
                appName,
                iosAppId,
                uri,
            },
        };
    };

const updateLensCtaWebsite =
    (website?: LensCtaWebsite) =>
    (lensCtaDraft: MyLensesLensCta): MyLensesLensCta => {
        if (!website) return lensCtaDraft;

        const { url } = website;

        return {
            ...lensCtaDraft,
            website: {
                url,
            },
        };
    };

// This helper method needed to remove __typename property that is not expected
// when a mutation sent to GraphQL layer
export const makeLensCtaFromLensForUpdate = (lensForUpdate: GetLensInfoResponse): MyLensesLensCta | null => {
    if (lensForUpdate.lens?.lensCta) {
        const { deeplink, text, type, website } = lensForUpdate.lens.lensCta;

        return flow(
            updateLensCtaDeeplink(deeplink ?? undefined),
            updateLensCtaWebsite(website ?? undefined),
        )({ text, type, deeplink, website });
    }
    return {
        type: MyLensesLensCtaType.CtaTypeUnset,
        text: MyLensesLensCtaText.CtaTextUnset,
    };
};
